import React from 'react';
import { Link } from 'react-router-dom';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { modelClass } from '/imports/api/supportTickets';
import { formatDateTime } from '/imports/utils';

/**
 * Lists support tickets with case number, subject, and last-updated columns.
 */
export const SupportTicketsPage = () => {
  return <ModelListPage
    modelClass={modelClass}
    columns={[
      { field: 'caseNumber', render: (ticket) => <Link to={`${modelClass.pathPrefix}/${ticket._id}`}>{ticket.caseNumber}</Link> },
      { field: 'subject' },
      { field: 'updatedAt', render: (ticket) => <span>{ticket.updatedAt && formatDateTime(ticket.updatedAt)}</span> },
    ]}
    defaultSort={{ updatedAt: -1 }}
  />;
};